import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { UserService } from 'src/app/student/services/user.service';
import { environment } from 'src/environments/environment';
import { CarouselResize } from 'src/app/shared/models/carousel-resize';
import { CustomCarouselComponent } from 'src/app/shared/components/custom-carousel/custom-carousel.component';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { HomeInstructorModel } from 'src/app/student/models/user.model';
import { CountryService } from 'src/app/services/country.service';
import { ItemDto } from 'src/app/@core/models/item.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-instructors',
  templateUrl: './instructors.component.html',
  styleUrls: ['./instructors.component.scss']
})
export class InstructorsComponent implements OnInit, OnDestroy {
  isRtl: boolean = true;
  firstName: string = '';
  secondName: string = '';
  countries: ItemDto[] = [];
  showInstructor: boolean = false;
  mediaUrl: string = environment.mediaUrl;
  private destroySubject: Subject<void> = new Subject();
  currentInstructor: HomeInstructorModel = {} as HomeInstructorModel;
  carouselResize: CarouselResize<HomeInstructorModel> = {
    data: [],
    items: [],
    itemSizeSm: 1,
    itemSizeMd: 3,
    itemSizeLg: 6,
    itemResize: 0,
    innerWidth: 0,
    currentIndex: 0,
    slideDelay: 500000
  }
  @ViewChild('appCustomCarousel') appCustomCarousel: CustomCarouselComponent<HomeInstructorModel>;
  constructor(private userService: UserService, private _CountryService: CountryService, private _LanguageService:LanguageService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }

  ngOnInit() {
    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getInstructors();
    this.getCountries();
  }
  
  // E2E-ISSUE-049: this used to read the paged `/users` directory (a full-PII list that now
  // requires the UserRead permission and answers 401 to a visitor). The home carousel reads the
  // public, personal-data-free projection instead.
  getInstructors(): void {
    this.userService.getHomeInstructors()
    .pipe(takeUntil(this.destroySubject))
    .subscribe({
      next: (data: HomeInstructorModel[]) => this.carouselResize.data = data ?? []
    })
  }

  getCountries(): void {
    this._CountryService.getCountries()
    .pipe(takeUntil(this.destroySubject))
    .subscribe((data: ItemDto[]) => this.countries = data);
  }

  getInstructorCountry(countryId: number): string {
    if(!countryId) return '';
    let currentCountry = this.countries.find(c => c.id === countryId);
    if(!currentCountry) return '';
    return this.isRtl ? currentCountry.nameAr : currentCountry.name;
  }

  showInstructorSlide(id: number): void {
    if(!id) return;
    let instructor = this.carouselResize.data.find(c => c.id === id);
    if(!instructor) return;
    let nameParts = (this.isRtl ? instructor.fullNameAr : instructor.fullName)?.split(" ") ?? [];
    this.firstName = nameParts[0] ?? '';
    this.secondName = nameParts[1] ?? '';
    this.currentInstructor = instructor;
    this.showInstructor = !this.showInstructor;
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
  }
}
